import React, { createContext } from 'react'
import { useQuery } from '@apollo/client'
import CentredLoader from '../components/CentredLoader'
import { CompanyStaffType } from '../types'
import { COMPANY_STAFFS_QUERY } from '../graphql/CompanyStaffs'

interface Iprops {
  contactId: number
  children: any
}

interface IStaffsContext {
  staffs: CompanyStaffType[]
  representantStaffs: CompanyStaffType[]
  refetch: any
}

export const CompanyStaffsContext = createContext({} as IStaffsContext)

const CompanyStaffsContextProvider = (props: Iprops) => {
  const { contactId } = props
  const { data, loading, refetch } = useQuery(COMPANY_STAFFS_QUERY, {
    variables: { contactId: contactId },
  })

  if (loading) {
    return <CentredLoader />
  }

  const staffs: CompanyStaffType[] = data.companyStaffs
  const representantStaffs: CompanyStaffType[] = staffs.filter(
    staff => staff.isRepresentant
  )

  return (
    <CompanyStaffsContext.Provider
      value={{ staffs, representantStaffs, refetch }}
    >
      {props.children}
    </CompanyStaffsContext.Provider>
  )
}

export default CompanyStaffsContextProvider
